export default __webpack_public_path__ + "static/media/VoucherWriteOff.92e93fae.xlsx";